import Vue from "vue";

// 金額表示
Vue.filter("addComma", function (val) {
  return val.toLocaleString();
});
